import { Bus } from './class.mjs';

const createSessionChangedBus = (params) => new Bus({ namespace: "session", ...params });
const createCookieChangedBus = (params) => new Bus({ namespace: "cookie", ...params });

export { createCookieChangedBus, createSessionChangedBus };
//# sourceMappingURL=index.mjs.map
